import Icon from "@cloudscape-design/components/icon"
import { Link } from "react-router-dom"
import ProtocolAlert from "../../../components/ProtocolAlert"
import UploadButton from "../../../components/UploadButton"

interface ProtocolEmptyStateProps {
  /**
   * Study ID for navigation links.
   */
  studyId: string
  /**
   * Whether an upload is currently in progress.
   */
  uploading: boolean
  /**
   * Error message from a failed upload attempt.
   */
  uploadError: string | null
  /**
   * Callback to trigger file picker.
   */
  onUploadClick: () => void
}

/**
 * Displayed when no protocol exists for a study.
 *
 * Provides two entry points for protocol creation: - "Create Protocol" button links to manual entry
 * form - "Upload Protocol PDF" triggers file picker for extraction flow.
 */
const ProtocolEmptyState = ({
  studyId,
  uploading,
  uploadError,
  onUploadClick,
}: ProtocolEmptyStateProps) => (
  <div className="protocol-empty">
    <span className="protocol-empty-icon">
      <Icon name="file" size="large" />
    </span>
    <h3>No Protocol</h3>
    <p>Upload or create a protocol to get started.</p>

    {uploadError && <ProtocolAlert message={uploadError} />}

    <div className="protocol-empty-actions">
      <Link
        to={`/studies/${studyId}/protocol/edit`}
        className="acdiv-btn-primary inline-flex items-center gap-1.5"
      >
        <Icon name="edit" size="normal" /> Create Protocol
      </Link>
      <UploadButton
        uploading={uploading}
        onClick={onUploadClick}
        label="Upload Protocol PDF"
        icon={<Icon name="upload" size="normal" />}
      />
    </div>
  </div>
)

export default ProtocolEmptyState
